var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 28C13.1 28 12.75 27.85 12.45 27.55C12.15 27.25 12 26.9 12 26.5V22.925H13.5V26.5H26.5V22.925H28V26.5C28 26.9 27.85 27.25 27.55 27.55C27.25 27.85 26.9 28 26.5 28H13.5ZM20 24.175L15.175 19.35L16.25 18.275L19.25 21.275V12H20.75V21.275L23.75 18.275L24.825 19.35L20 24.175Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download_file.56e0176001153aabe30765b82dca78fc.svg";
export { ForwardRef as ReactComponent };